import { render, staticRenderFns } from "./DutyInspectCategory.vue?vue&type=template&id=ec79c180&scoped=true"
import script from "./DutyInspectCategory.vue?vue&type=script&lang=js"
export * from "./DutyInspectCategory.vue?vue&type=script&lang=js"
import style0 from "./DutyInspectCategory.vue?vue&type=style&index=0&id=ec79c180&prod&scoped=true&lang=css"
import style1 from "./DutyInspectCategory.vue?vue&type=style&index=1&id=ec79c180&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec79c180",
  null
  
)

export default component.exports